
import { useEffect } from 'react';
import useGlobalContext from "../../context/useGlobalContext";
import useDisplaySnackbar from '../../utils/useDisplaySnackbar';
import React, { useState } from 'react';
import { Box } from '@mui/material';
import Datatable from ".././Common/Datatable";
import { getColumns, initialSort } from ".././Meetings/meetingsTableConfig";
import { convertToUTC } from '../../utils/utils';
import UserInteractionsService from '../../services/interactions/Interactions';
import { getUserAttributes } from '../../utils/auth';

const generateRows = (meetings: any) =>
    meetings.map((item: any) => ({
        id: item.interactionId,
    title: item.interactionTitle,
    start_time: item.startTime,
    end_time: item.endTime,
    duration: item.duration,
    no_of_attendees: item.noOfAttendees,
    is_external: item.isExternal,
    attendees: item.attendees,
    organizer: item.empEmail,
    sentiment_score: item.sentimentScore,
    meeting_sentiment: item.overallSentiment,
    join_link: item.joinLink,
    role_in_interaction: item.roleInInteraction,
    response_status: item.responseStatus,
    profile_org_ids: item.profileOrgRelationshipIds,
    rating_source: item.ratingSource,
    botStatus: item.botStatus,
    clientDomains: item.clientDomains,
    abstractiveScore: item.abstractiveScore,
    }));

const PeopleSearchMeetingsView: React.FC<{ personEmail: string, profileOrgId?: string | undefined }> = ({ personEmail, profileOrgId }) => {
    const [columns] = useState<any[]>(getColumns());
    const [rows, setRows] = useState<any[]>([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const { calendar, startEndTime, timeRange } = useGlobalContext();
    const { showSnackbar } = useDisplaySnackbar();
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [search, setSearch] = useState<string>("");
    const { startEndMeetingTime, accountDetails } = useGlobalContext();
    const [sort, setSort] = useState(initialSort);
    console.log(search);
    const today = new Date();
    const endOfToday = new Date(today);
    endOfToday.setHours(today.getHours(), today.getMinutes(), 0, 0);
    const startOfSixMonthsAgo = new Date(today);
    startOfSixMonthsAgo.setMonth(today.getMonth() - 12);
    startOfSixMonthsAgo.setHours(0, 0, 0, 0);
    const loggedInEmail = getUserAttributes()?.email;
    const isHighRadiusUser = loggedInEmail?.endsWith("@highradius.com");
    const loggedInProfileOrgId = accountDetails?.profileOrgId ?? "";

    const {
        isLoading: isDataLoading,
        isFetching: isDataFetching,
        isSuccess,
        isError,
        error,
        data: meetingsData,
    } = UserInteractionsService.useGetGlobalSearchInteractions(
        {
        startTime: convertToUTC(startEndMeetingTime?.start_time),
        endTime: convertToUTC(startEndMeetingTime?.end_time),
        offset: pageNumber,
        limit: pageSize,
        sortBy: sort.sort_field,
        sortOrder: sort.sort_order,
        employeePorId: loggedInProfileOrgId,
        searchEmail: personEmail,
        searchProfileOrgId: profileOrgId,
        },
        !!profileOrgId
      );
    useEffect(() => {
        setShowSpinner(isDataLoading || isDataFetching);

        if (isSuccess) {
            const meetingList = meetingsData.data;
            setTotalRecord(meetingsData.data.totalRecords);
            if (meetingList) {
                setRows(generateRows(meetingList));
            }
        }
        if (isError) {
            showSnackbar("error", error);
        }
    }, [isDataLoading, isDataFetching, isSuccess, isError, meetingsData]);
    
    const onPageChange = (value: number) => {
        setPageNumber(value);
    };

    const onPaginationChange = (pageNumber: number) => {
        onPageChange(pageNumber + 1);
    };

    const onSearch = (value: string) => {
        setSearch(value);
        setPageNumber(1);
    };

    const onGlobalFilterChange = (globalFilter: any) => {
        onSearch(globalFilter);
    };


    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
      };

    const onSortingChange = (sorting: any[]) => {
        if (sorting && sorting.length > 0)
            setSort({
                sort_field: sorting[0].id,
                sort_order: sorting[0].desc === true ? "desc" : "asc",
            });
    };

    return (
        <>
            <Box
                className="flex flex-col justify-start items-start w-full"
                sx={{ gap: "12px" ,marginTop:"10px"}}
            >
               
                <Box className="w-full">
                    <Datatable
                       // header={"Meetings"}
                        columns={columns}
                        rows={rows}
                        rowCount={totalRecord}
                        pageSize={pageSize}
                        initialSort={sort}
                        onPaginationChange={onPaginationChange}
                        onSortingChange={onSortingChange}
                        onGlobalFilterChange={onGlobalFilterChange}
                        startEndTime={startEndTime}
                        timeRange={timeRange}
                        calendarId={calendar?.calendar_id}
                        onPageSizeChange={(newPageSize: number | null | undefined) => {
                            if (newPageSize !== null && newPageSize !== undefined) {
                              handlePageSizeChange(newPageSize);
                            }
                          }}
                        columnVisibility={{ actual_duration: false, sharedDate: false,
                             abstractiveScore: isHighRadiusUser, shareIcon: false,
                              meeting_sentiment : !isHighRadiusUser,
                              talkTrack: false,
                              is_manager: false,
                             }}  
                        showSpinner={showSpinner}
                    />
                </Box>
            </Box>
        </>
    );
};

export default PeopleSearchMeetingsView;
